import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class GetLiteInfoService {
  private _env: string = this.env._env;
  private url = null;

  constructor(private http: HttpClient, private env: EnvironmentService) { }

  public getContalinkLiteInfo(getLiteInfo: GetLiteInfo): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders().set('X-Api-Key', environment[this._env]['back_end_api_token']);
    let params = new HttpParams().set("lite_code", getLiteInfo.lite_code);
    this.url = `${environment[this._env]['back_end_url']}/liteinfo`;

    return this.http.get(this.url, {
      headers: headers,
      params: params
    });
  }
}
export interface GetLiteInfo {
  lite_code: string
}